import React, { useState, useEffect } from "react";
import { useCart } from "react-use-cart";
import BottomNavigation from "../components/BottomNavigation";
import { useNavigate } from "react-router-dom";
import { Form, Field } from "react-final-form";
import { useCustomFields } from "./CustomFields";
import { useIndexedDB } from "react-indexed-db";
import { strings } from "../localization";
import { isDiscounted, getDiscountPrice } from '../components/Cart';

const validate = (values) => {
  const errors = {};

  if (!values.customer) errors.customer = "Le client est obligatoire";

  return errors;
};

const SelectClientForm = (props) => {
  const { getAll, update } = useIndexedDB("catalog");
  const [currentClient, setCurrentClient] = useState(null);
  const [clientInitialValue, setClientInitialValue] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [saved, setSaved] = useState(false);
  const navigate = useNavigate();
  const { items, addItem, inCart, removeItem, getItem } = useCart();

  useEffect(() => {
    getAll().then((dataFromDB) => {
      let foundCustomers =
        dataFromDB.find((i) => i.type === "customers")?.data ?? [];
      setCustomers(foundCustomers);
    });

    if (sessionStorage.getItem('orders.current_client')) {
        setCurrentClient(JSON.parse(sessionStorage.getItem('orders.current_client')));
    }
  }, []);

  useEffect(() => {
    if (currentClient && clientInitialValue === null) {
      setClientInitialValue({ customer: currentClient.ref })
    }
  }, [currentClient, clientInitialValue])

  const getProductPackUnit = (id, defaultVal) => {
      return sessionStorage.getItem('products.productPackUnit.' + id) ? parseInt(sessionStorage.getItem('products.productPackUnit.' + id)) : defaultVal;
  }

  const handleSave = async (values) => {
    setSaved(true);
    if (values.customer) {
      let customer = customers.find((c) => c.ref === values.customer);
      sessionStorage.setItem('orders.current_client', JSON.stringify(customer));
      sessionStorage.removeItem('orders.demo_client_access');
      sessionStorage.removeItem('orders.after_client_redirect');
      setCurrentClient(customer);
      updateCartValues(customer);

      navigate("/dashboard");
    }
  };

  const handleContinueWithoutClient = () => {
    const redirectPath = sessionStorage.getItem('orders.after_client_redirect') || '/products';

    sessionStorage.removeItem('orders.current_client');
    sessionStorage.removeItem('orders.after_client_redirect');
    sessionStorage.setItem('orders.demo_client_access', JSON.stringify(true));
    setCurrentClient(null);

    navigate(redirectPath);
  };

  const updateCartValues = (customer) => {
    if (items.length === 0) {
      return false;
    }

    let prevCartProducts = [];
    items.forEach(item => {
      prevCartProducts.push(JSON.parse(JSON.stringify(item)));
    });
    localStorage.setItem('prevCartProducts', JSON.stringify(prevCartProducts))
    
    // clear cart
    let tempCartData = JSON.parse(localStorage.getItem('react-use-cart'));
    tempCartData.items = [];
    tempCartData.cartTotal = 0;
    tempCartData.isEmpty = true;
    tempCartData.totalItems = 0;
    tempCartData.totalUniqueItems = 0;
    localStorage.setItem('react-use-cart', JSON.stringify(tempCartData));

    // update to cart
    setTimeout(() => {
      const itemsToAdd = JSON.parse(localStorage.getItem('prevCartProducts'))
      let newCartData = JSON.parse(localStorage.getItem('react-use-cart'));
      newCartData.isEmpty = false;
      newCartData.totalUniqueItems = itemsToAdd.length;

      let newItems = [];
      itemsToAdd.forEach(prevProduct => {
        const discount = (prevProduct.discount !== null && typeof prevProduct.discount === 'object') ? prevProduct.discount : customer.general_discount;
        const price = !prevProduct.destock && discount && isDiscounted(prevProduct.quantity, discount) ? getDiscountPrice(prevProduct.regular_price, discount?.amount) : prevProduct.regular_price;
        const itemTotal = price * prevProduct.quantity;
        newItems.push({ 
          id:prevProduct.id, 
          price: price, 
          name: prevProduct.name, 
          image: prevProduct.image, 
          pack_unit : getProductPackUnit(prevProduct.id, prevProduct.pack_unit), 
          regular_price: prevProduct.regular_price, 
          discount: discount, 
          destock: prevProduct.destock,
          itemTotal: itemTotal,
          quantity: prevProduct.quantity
        })
      });

      newCartData.items = newItems;
      let sumTotal = 0;
      newItems.forEach((el) => sumTotal += el.itemTotal);
      let sumItems = 0;
      newItems.forEach((el) => sumItems += el.quantity);
      newCartData.cartTotal = sumTotal;
      newCartData.totalItems = sumItems;

      localStorage.setItem('react-use-cart', JSON.stringify(newCartData));
      localStorage.removeItem('prevCartProducts');
    }, 300);
  }

  const [{ RenderCustomerField }] = useCustomFields();

  return (
    <Form
      onSubmit={handleSave}
      validate={validate}
      initialValues={clientInitialValue}
      render={({ handleSubmit, form, submitting, pristine, values, dirty }) => {
        return (
          <>
            <form onSubmit={handleSubmit} className="select-client-form my-5">
              <div className="container-lg">
                <div className="row d-block">
                  <div className="border-1 border-white border p-3 bg-primary">
                    <h2 className='mt-2 mb-5 text-center'>{ strings.select_client_title}</h2>
                    <div className="row mt-3">
                      <Field
                        name="customer"
                        customFormat={(value, name) => {
                          let customer = customers?.find(
                            (c) => c.ref === value
                          );
                          return customer
                            ? { value: customer.ref, label: customer.company }
                            : "";
                        }}
                        customParse={(value, name) =>
                          value ? value.value : ""
                        }
                        label={strings.client_commande}
                        styles="z-index:1000;"
                        classes={{ label: "col-2", input: "col-6" }}
                        component={RenderCustomerField}
                        placeholder={strings.rechercher_client}
                        options={customers?.map((c) => {
                          return { value: c.ref, label: c.company };
                        })}
                        isDisabled={false} 
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <BottomNavigation className="justify-content-around">
              <button
                type="button"
                onClick={handleContinueWithoutClient}
                className="btn btn-lg col-auto"
              >
                <i className="fs-1 fa fa-eye me-3"></i>
                {strings.continue_without_client}
              </button>
              <button
                type="button"
                disabled={!dirty}
                onClick={() => {
                  form.submit();
                }}
                className={
                  "btn btn-lg col-auto active" + (saved ? " text-success" : "")
                }
              >
                {saved ? (
                  <>
                    <i className="fs-1 fa fa-check me-3"></i> {strings.saved}
                  </>
                ) : (
                  <>
                    <i className="fs-1 fa fa-save me-3"></i>{" "}
                    {strings.enregistrer}
                  </>
                )}
              </button>
            </BottomNavigation>
          </>
        );
      }}
    />
  );
};

export default SelectClientForm;
